/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse } from '@angular/common/http';
import { errorStrings } from '@core/strings';
import { ActionCreator } from '@ngrx/store';
import { Observable, of } from 'rxjs';

export const formatError = (error: HttpErrorResponse): string =>
  error.error ? error.error.message || error.error.Message : error.message;

export const handleError = (
  error: HttpErrorResponse,
  action: ActionCreator,
): Observable<any> => {
  const errorMessage = formatError(error) ?? errorStrings[0].value.toString();

  return of(action({ error, message: errorMessage }));
};
